

import { BoxAlarmComponent } from './alarm.box';
import { CloudAlarmComponent } from './alarm.cloud';
import { DemoAlarmComponent } from './alarm.demo';

import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

export default class System extends mixin(environment.nexus, {
  box: BoxAlarmComponent,
  cloud: CloudAlarmComponent,
  demo: DemoAlarmComponent
}) { }
